export default "__VITE_ASSET__DM4TnC_2__"